import { Helmet }                          from 'react-helmet';
import ActiveProcessesTable                from 'components/tables/ActiveProcessesTable';
import PageContainer                       from 'components/common/PageContainer';
import { useTranslation }                  from 'react-i18next';
import { useConfig }                       from 'hooks/config';

const MyActiveProcesses = () => {
  const { t }       = useTranslation()
  const { project } = useConfig()

  return (
    <>
      <Helmet>
        <title>{t('menu.instances.mine')} | {project}</title>
      </Helmet>
      <PageContainer>
        <ActiveProcessesTable mode="my"/>
      </PageContainer>
    </>
  );
}

export default MyActiveProcesses
